import Autocomplete from 'react-autocomplete';

import { autocompleteCompanyName } from '~/lib/client';

export default class CompanyName extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],
    };
  }

  onChange = (event) => {
    this.props.onChange && this.props.onChange(event);
    this.fetchSuggestions(event.target.value);
  };

  setSuggestions = (suggestions) => {
    this.setState({ suggestions });
  };

  fetchSuggestions = (query) => {
    if (!query) return this.setState({ suggestions: [] });

    autocompleteCompanyName({ query }).then((suggestion) => {
      this.setSuggestions(suggestion);
    });
  };

  renderSuggestion = (item, isHighlighted) => {
    return (
      <div
        key={item.domain}
        className={classnames('cb-suggestion', { 'cb-hl': isHighlighted })}>
        <div className="cb-logo">
          {item.logo && <img src={item.logo + '?s=25'} alt="company logo" />}
        </div>
        <div className="cb-name">{item.name}</div>
        <div className="cb-domain">{item.domain}</div>
      </div>
    );
  };

  renderMenu = (items) => {
    return <div className="cb-autocomplete">{items}</div>;
  };

  renderInput = (defaultProps) => {
    // Remove autoComplete=off from props
    const { autoComplete: _autoComplete, ...props } = defaultProps;

    return (
      <input
        {...props}
        name={'company_name'}
        autoComplete={'clearbit-company-name'}
      />
    );
  };

  render() {
    const { id, ...props } = this.props;

    return (
      <div className="cb-company-name">
        <Autocomplete
          {...props}
          getItemValue={(item) => item.name}
          items={this.state.suggestions}
          renderItem={this.renderSuggestion}
          wrapperStyle={{ position: 'relative' }}
          renderMenu={this.renderMenu}
          renderInput={this.renderInput}
          onChange={this.onChange}
          inputProps={{
            id,
            required: this.props.required,
            placeholder: this.props.placeholder,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur,
          }}
        />
      </div>
    );
  }
}

CompanyName.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
};
